
import { defineComponent, PropType } from 'vue'
import { Payment } from '@/types/order'

export default defineComponent({
  props: {
    payment: {
      type: Object as PropType<Payment>,
      required: true
    },
    useRegisteredCreditCard: {
      type: Boolean,
      required: true
    }
  }
})
